import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-gt.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-gt.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ViewApplicationService } from "../../../view-application.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../../shared/models/alert";
import { GautrainService } from "../../../../../shared/services/modules/gautrain.service";
import { ViewApplicationDetailsGtConstants } from "./view-application-details-gt.constants";
let ViewApplicationDetailsGtComponent = class ViewApplicationDetailsGtComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    gautrainService;
    viewApplicationService;
    route;
    routerParamsService;
    appController;
    changeDetectorRefs;
    detailsForm;
    validationMessages = ViewApplicationDetailsGtConstants.VALIDATION_MESSAGES;
    descriptionFormControlName = ViewApplicationDetailsGtConstants.DESCRIPTION_FORM_CONTROL_NAME;
    amendmentSchemeNumberFormControlName = ViewApplicationDetailsGtConstants.AMENDMENT_SCHEME_NUMBER_FORM_CONTROL_NAME;
    fileNumberFormControlName = ViewApplicationDetailsGtConstants.FILE_NUMBER_FORM_CONTROL_NAME;
    applicationTypesFormControlName = ViewApplicationDetailsGtConstants.APPLICATION_TYPES_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsGtConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    referenceNumberControlName = ViewApplicationDetailsGtConstants.REFERENCE_NUMBER_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    addApplicationTypeLabel = ViewApplicationDetailsGtConstants.ADD_APPLICATION_TYPE_LABEL;
    referenceNumberLabel = ViewApplicationDetailsGtConstants.REFERENCE_NUMBER_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    applicationTypeLabel = ViewApplicationDetailsGtConstants.APPLICATION_TYPE_LABEL;
    descriptionLabel = ViewApplicationDetailsGtConstants.DESCRIPTION_LABEL;
    amendmentSchemeNumberLabel = ViewApplicationDetailsGtConstants.AMENDMENT_SCHEME_NUMBER_LABEL;
    fileNumberLabel = ViewApplicationDetailsGtConstants.FILE_NUMBER_LABEL;
    applicationTypes = [];
    saveBtnPlaceholder = ViewApplicationDetailsGtConstants.SAVE_BUTTON_PLACEHOLDER;
    application;
    applicationTypesControl;
    getApplicationSaveObservableSubscription;
    getApplicationSetApplicationTypesObservableSubscription;
    constructor(aflaModuleStrategyService, gautrainService, viewApplicationService, route, routerParamsService, appController, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.gautrainService = gautrainService;
        this.viewApplicationService = viewApplicationService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        if (this.aflaModuleStrategyService.lookups.has("applicationTypes")) {
            this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
            this.getApplication();
        }
        else {
            this.getLookups();
        }
    }
    getApplication() {
        const params = {
            $expand: `applicationTypes`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .subscribe((response) => this.onGetApplicationCompleted(response), (error) => {
            this.appController.handleServerErrorMessage(ViewApplicationDetailsGtConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    getApplicationTypes() {
        return this.detailsForm.get("applicationTypes");
    }
    onBtnRemoveApplicationTypeClicked(i) {
        const controls = this.getApplicationTypes();
        if (controls.controls.length > 1) {
            controls.removeAt(i);
        }
    }
    onBtnAddApplicationTypeClicked() {
        const applicationTypesControl = this.getApplicationTypes();
        const typeGroup = new FormGroup({
            id: new FormControl(0),
            applicationId: new FormControl(0),
            type: new FormControl(null, [Validators.required])
        });
        applicationTypesControl.push(typeGroup);
    }
    onBtnSaveClicked() {
        if (this.detailsForm.valid) {
            const app = {
                amendmentSchemeNumber: this.detailsForm.get(this.amendmentSchemeNumberFormControlName).value,
                fileNumber: this.detailsForm.get(this.fileNumberFormControlName).value,
            };
            const typeParams = {
                types: []
            };
            const typeControls = this.getApplicationTypes();
            typeControls.controls.forEach(typeControl => {
                const type = {
                    id: typeControl.get("id").value,
                    applicationId: typeControl.get("applicationId").value,
                    applicationType: typeControl.get("type").value.value,
                    deleted: false
                };
                typeParams.types.push(type);
            });
            this.getApplicationSaveObservableSubscription =
                this.viewApplicationService.getApplicationSaveObservable(this.aflaModuleStrategyService.applicationServiceUrl, this.application.id, app)
                    .subscribe(appSaveresponse => {
                    this.setTypes(typeParams);
                }, error => {
                    this.appController.handleServerErrorMessage(ViewApplicationDetailsGtConstants.STEP_TITLE, error, CRUDOperation.Update);
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    handleRouteChange() {
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.detailsForm.reset();
            const application = response.value[0];
            this.application = application;
            this.detailsForm.get(this.amendmentSchemeNumberFormControlName).setValue(application.amendmentSchemeNumber);
            this.detailsForm.get(this.fileNumberFormControlName).setValue(application.fileNumber);
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
            this.detailsForm.get(this.referenceNumberControlName).setValue(application.referenceNumber);
            this.detailsForm.get(this.descriptionFormControlName).disable();
            this.detailsForm.get(this.referenceNumberControlName).disable();
            const typesControl = this.getApplicationTypes();
            typesControl.clear();
            application.applicationTypes.forEach(applicationType => {
                let appType = null;
                this.applicationTypes.forEach(item => {
                    if (item.value === applicationType.applicationType) {
                        appType = item;
                    }
                });
                const typeGroup = new FormGroup({
                    id: new FormControl(applicationType.id),
                    applicationId: new FormControl(applicationType.applicationId),
                    type: new FormControl(appType, [Validators.required])
                });
                typesControl.push(typeGroup);
            });
        }
        this.changeDetectorRefs.detectChanges();
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.moduleID} and name eq 'ApplicationType' and deleted eq false`,
        };
        this.viewApplicationService
            .getLookupsObservable(params)
            .subscribe((response) => this.onGetLookupsCompleted(response), (error) => {
            this.appController.handleServerErrorMessage(ViewApplicationDetailsGtConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    applicationTypes.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.applicationTypes = applicationTypes;
        this.getApplication();
    }
    setTypes(typeParams) {
        this.getApplicationSetApplicationTypesObservableSubscription =
            this.gautrainService.getApplicationSetApplicationTypesObservable(this.application.id, typeParams)
                .subscribe(addTypesResponse => {
                this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
            }, error => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsGtConstants.STEP_TITLE, error, CRUDOperation.Update);
            });
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: GautrainService },
        { type: ViewApplicationService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsGtComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-details-gt",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsGtComponent);
export { ViewApplicationDetailsGtComponent };
